import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  getCurrentPredictionStep,
  getPredictionRunningState,
} from "../../../store/selectors/PredictionSelectors";
import FileUpload from "../../../components/FileUpload";
import { uploadScrewImagesAction } from "../../../store/actions/ScrewsActions";
import { getScrewUploadStatus } from "../../../store/selectors/ScrewSelectors";
import { resetScrewUpload } from "../../../store/reducers/ScrewsReducers";
import {
  resetPredictionSlice,
  updatePredictionStep,
} from "../../../store/reducers/PredictionReducers";
import PredictionOverview from "../../../components/Model/PredictionOverview";
import ViewPredictionResultsScrews from "../../../components/Model/ViewPredictionResultsScrews";

const ScrewModel = () => {
  const dispatch = useAppDispatch();
  const predictionStep = useAppSelector(getCurrentPredictionStep);
  const screwUploadStatus = useAppSelector(getScrewUploadStatus);
  const predictionRunningState = useAppSelector(getPredictionRunningState);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  useEffect(() => {
    return function () {
      setSelectedFile(null);
      dispatch(resetPredictionSlice());
      dispatch(resetScrewUpload());
      setSelectedFile(null);
    };
  }, [dispatch]);

  const handleFileSubmission = useCallback(() => {
    if (!selectedFile) return;
    
    const formData = new (globalThis as any).FormData();
    formData.append("images", selectedFile, selectedFile.name);
    dispatch(uploadScrewImagesAction(formData));
  }, [selectedFile, dispatch]);

  const fileUploadProps = useCallback(
    () => ({
      isFileUploading: screwUploadStatus === "loading",
      selectedFile: selectedFile,
      showCancel: false,
      onFileChange: setSelectedFile,
      onCancelUpload: () => console.log("soon"),
      handleFileSubmission,
      modelType: "screw",
      allowMultiple: false, // Predictions should only allow single files
    }),
    [selectedFile, screwUploadStatus, handleFileSubmission]
  );

  useEffect(() => {
    if (screwUploadStatus === "idle") {
      setSelectedFile(null);
      dispatch(updatePredictionStep(1));
      return;
    }

    if (screwUploadStatus !== "success") return;
    dispatch(updatePredictionStep(2));
  }, [screwUploadStatus, dispatch]);

  useEffect(() => {
    if (predictionRunningState === "error" && selectedFile !== null)
      setSelectedFile(null);
  }, [selectedFile, predictionRunningState]);

  return (
    <div className="screw-model">
      {predictionStep === 1 && <FileUpload {...fileUploadProps()} />}
      {predictionStep === 2 && <PredictionOverview />}
      {predictionStep === 3 && <ViewPredictionResultsScrews />}
    </div>
  );
};

export default ScrewModel;
